import React, {useContext, useState} from "react"
import PropTypes from "prop-types";
import Loading from "components/Loading";
import FormTranslationContext from "context/FormTranslationContext";
import {Table, TableBody, TableHead, TableRow, Tooltip} from "@material-ui/core";
import AnnualReportTableHeadCell from "../common/AnnualReportTableHeadCell";
import Tr from "translations/Translations";
import AnnualReportEditPopup from "../common/AnnualReportEditPopup";
import AnnualReportInnovativeEditForm from "./AnnualReportInnovativeEditForm";
import annualReportSteps from "../../constants/annualReportSteps";
import MoveAnnualReportEntry from "../common/MoveAnnualReportEntry";
import AnnualReportTablePart from "../common/AnnualReportTablePart";
import formatAmountNumber from "libs/formatAmountNumber";
import formatBoolean from "libs/formatBoolean";
import AnnualReportTableCell from "../common/AnnualReportTableCell";
import AnnualReportSearchBar from "../common/AnnualReportSearchBar";
import annualReportTenderMode from "../../constants/annualReportTenderMode";


const reportStep = annualReportSteps.innovative;

function AnnualReportInnovativeForm(
    {
        initValues,
        classes,
        disabled
    }
) {
    const {getDict, dictTranslations} = useContext(FormTranslationContext);
    const [types] = useState(getDict("MP.MMiA.OrdersType"));
    const [editPopup, setEditPopup] = useState(null);
    const [movePopup, setMovePopup] = useState(null);
    const [search, setSearch] = useState({search: ""});


    const getRowValues = (entry) => ([
        entry.number,
        entry.source ? dictTranslations.source[entry.source] : null,
        entry.noticeNumber,
        entry.orderType ? dictTranslations.orderType[entry.orderType] : null,
        entry.codeCpv ? <Tooltip title={entry.codeCpv.name}><span>{entry.codeCpv.publicCode}</span></Tooltip> : null,
        annualReportTenderMode(entry, dictTranslations),
        formatAmountNumber(entry.contractValue),
        formatBoolean(entry.environmentalRequirements),
        formatBoolean(entry.environmentalManagementSystemAndStandards),
        formatBoolean(entry.environmentalAspectsInEvaluationCriteria),
        formatBoolean(entry.costCriterionUsingLifeCycleCostingApplied),
        formatBoolean(entry.environmentalAspectsRequirements),
        formatBoolean(entry.labelRelatedToEnvAspectsOrMeasureOfEvidence),
        formatBoolean(entry.innovativeAspectsInEvaluationCriteria),
        formatBoolean(entry.innovativeAspectsRequirements),
    ])

    if (!initValues) return <Loading/>
    return <>
        <AnnualReportSearchBar reportStep={reportStep} setSearch={setSearch} classes={classes} disabled={disabled} setEditPopup={setEditPopup}/>

        <Table>
            <TableHead>
                <TableRow className={classes.tableMainHeaderRow}>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.number`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.source`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.noticeNumber`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.orderType`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.codeCpv`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.tenderModeBzp`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.contractValue`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.environmentalRequirements`} maxWidth={100}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.environmentalManagementSystemAndStandards`} maxWidth={100}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.environmentalAspectsInEvaluationCriteria`} maxWidth={100}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.costCriterionUsingLifeCycleCostingApplied`} maxWidth={100}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.environmentalAspectsRequirements`} maxWidth={100}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.labelRelatedToEnvAspectsOrMeasureOfEvidence`} maxWidth={100}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.innovativeAspectsInEvaluationCriteria`} maxWidth={100}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.innovativeAspectsRequirements`} maxWidth={100}/>
                    <AnnualReportTableCell borderLeft borderRight colSpan={2}></AnnualReportTableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    types.map((type) =>
                        <AnnualReportTablePart
                            key={type.value}
                            classes={classes}
                            type={type.value}
                            reportStep={reportStep}
                            partName={dictTranslations.type[type.value]}
                            disabled={disabled}
                            entries={initValues[type.value]}
                            search={search}
                            setEditPopup={setEditPopup}
                            setMovePopup={setMovePopup}
                            columnCount={15}
                            getRowValues={getRowValues}
                        />
                    )
                }
            </TableBody>

        </Table>

        {
            !!editPopup &&
            <AnnualReportEditPopup
                onClose={() => setEditPopup(null)}
                config={editPopup}
                reportStep={reportStep}
                FormComponent={AnnualReportInnovativeEditForm}
            />
        }
        {
            !!movePopup &&
            <MoveAnnualReportEntry
                items={types.filter((item) => item.value !== movePopup.currentType)}
                onClose={() => setMovePopup(null)}
                inputLabel={Tr("order_type")}
                reportStep={reportStep}
                config={movePopup}
            />
        }
    </>


}

AnnualReportInnovativeForm.prototype = {
    initValues: PropTypes.object.isRequired,
    disabled: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired
}

export default AnnualReportInnovativeForm;